<template>
  <div>
    <header><label>New Baby {{index + 1}}</label></header>
    <div class="indent form__row--x">
      <label>Pediatric Aging</label>
      <div class="form__row">
        <input type="number" v-model="infant.pediatricAge" :disabled="isClose">
      </div>
    </div>

    <div class="indent form__row--x">
      <div class="form__row max-AOG">
        <div class="smd-input-label">
          <label>Birth Weight (grams)</label><br/>
          <input type="number" v-model="infant.pediatricWeight" :disabled="isClose">
        </div>
        <div class="smd-input-label">
          <label>Birth Height (cm)</label><br/>
          <input type="number" v-model="infant.pediatricHeight" :disabled="isClose">
        </div>
      </div>
    </div>
    <div class="indent form__row--x">
      <div class="form__row max-AOG">
        <div class="smd-input-label">
          <label>1-minute APGAR Score</label><br/>
          <input type="number" v-model="infant.apgar1m" :disabled="isClose">
        </div>
        <div class="smd-input-label">
          <label>5-minute APGAR Score</label><br/>
          <input type="number" v-model="infant.apgar5m" :disabled="isClose">
        </div>
      </div>
    </div>
    <div class="indent form__row--x">
      <label>Any injuries to the Newborn?</label>
      <div class="form__row">
        <select v-model="infant.injury" :disabled="isClose">
          <option v-for="status in $options.neonatalInjury()"
                  :value="status.id"
                  :key="status.id">
            {{ status.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="indent form__row--x">
      <label>Status</label>
      <div class="form__row">
        <select v-model="infant.status" :disabled="isClose">
          <option v-for="status in $options.neonatalStatus()"
                  :value="status.id"
                  :key="status.id"
                  :disabled="status['hidden'] === true">
            {{ status.name }} <span v-if="status['hidden'] === true">&nbsp;&nbsp;(PHASED OUT)</span>
          </option>
        </select>
      </div>
    </div>
    <div class="indent form__row--x" v-if="checkInfantMortality(infant.status)">
      <div class="form__row">
        <div class="smd-input-label">
          <label>Cause of Death</label><br/>
          <select v-model="infant.causeofdeath" :disabled="isClose">
            <option v-for="status in $options.neonatalCauseOfDeathCategory()"
                    :value="status.id"
                    :key="status.id">
              {{ status.name }}
            </option>
          </select>
        </div>
        <div class="smd-input-label">
          <label>Specific Cause</label><br/>
          <select v-model="infant.specificcause" :disabled="isClose">
            <option v-for="status in neonatalDeathSpecificCauses"
                    :value="status.id"
                    :key="status.id">
              {{ status.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form__row">

      </div>
    </div>
    <div class="indent form__row--x" v-if="checkInfantMortality(infant.status)">
      <label>Has case been reviewed by the steering committee/department?</label>
      <div class="form__row">
        <smd-segment type="pill"
                     v-model="deathReviewed"
                     :items="$options.booleanChoices"
                     :style="highlightIfError('deathReviewed')"
                     :disabled="isClose"/>
      </div>
    </div>

    <div class="indent form__row--x">
      <label>Congenital Anomalies</label>
      <smd-segment type="pill"
                   v-model="infant.anomalies"
                   :items="$options.congenitalAnomalies"
                   :disabled="isClose"/>
    </div>
    <div class="indent form__row--x" v-if="infant.anomalies">
      <label>Please specify anomaly: </label>
      <input v-model="infant.anomalyOthers" :disabled="isClose"/>
    </div>

  </div>
</template>

<script>
  import withErrorValidation from '../../../mixins/with-error-validation-mixin';
  import {createHelpers} from 'vuex-map-fields'

  import {
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
  } from '../../../store/forms/case-form-state'

  import {
    getMapFn,
    REF_MATERNAL_FETAL_FORM_NEONATAL_CONDITIONS,
    REF_MATERNAL_FETAL_FORM_NEONATAL_INJURY,
    REF_NEONATAL_CAUSEOFDEATH_CONDITIONS,
    REF_NEONATAL_CAUSEOFDEATH,
    REF_NEONATAL_CAUSEOFDEATH_OBJ,
    REF_NEONATAL_CAUSEOFDEATH_CONDITIONS_OBJ
  } from '../../../store/modules/referencedata2'

  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  export default {
    mixins: [withErrorValidation],
    props: {
      infant: {required: true},
      index: {required: true}
    },
    computed: {
      ...mapFields([
        'isClose',
        'deathReviewed'
      ]),
      neonatalDeathSpecificCauses() {
        if (this.infant.causeofdeath === null)
          return [];
        else  {
          let result = getMapFn(REF_NEONATAL_CAUSEOFDEATH_OBJ)()[this.infant.causeofdeath]
          return result ? result.conditions : []
        }
      }
    },
    methods: {
      checkInfantMortality(status) {
        return [2,3,4,5,6].includes(status)
      }
    },
    congenitalAnomalies: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    neonatalStatus: getMapFn(REF_MATERNAL_FETAL_FORM_NEONATAL_CONDITIONS),
    neonatalInjury: getMapFn(REF_MATERNAL_FETAL_FORM_NEONATAL_INJURY),
    neonatalCauseOfDeathCategory: getMapFn(REF_NEONATAL_CAUSEOFDEATH),
    neonatalCauseOfDeath: getMapFn(REF_NEONATAL_CAUSEOFDEATH_CONDITIONS),
    booleanChoices: [
      {id: 1, name: 'YES', val: true},
      {id: 2, name: 'NO', val: false}
    ],
    watch :{
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scaffolding/scss/pogs-util";

  .max-AOG{
    input{
      max-width: 115px;
    }
  }
</style>
